"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _memoize2 = _interopRequireDefault(require("lodash/memoize"));
var _localization = require("@lt/localization");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Plus = _interopRequireDefault(require("../../../icons-react/rebrand/Plus"));
var _pluralizeUtils = require("../../../utils/pluralizeUtils");
var _CustomList = _interopRequireDefault(require("./CustomList"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * Генерирует необходимое количество option
 * @param {number} minAge
 * @param {number} maxAge
 */
var makeOptions = (0, _memoize2["default"])(function (minAge, maxAge) {
  var arraySize = maxAge - minAge + 1;
  var options = new Array(arraySize).fill(null).map(function (_, index) {
    var value = minAge + index === 0 ? 0 : minAge + index;
    var title = index === 0 ? _localization.i18n.t('touristsPicker.oneYear') : (0, _pluralizeUtils.pluralizeYears)(value);
    return {
      title: title,
      value: value
    };
  });
  options.unshift({
    title: _localization.i18n.t('touristsPicker.age'),
    value: -1
  });
  return options;
});
var AddChild = function AddChild(_ref) {
  var onAddChild = _ref.onAddChild,
    minChildAge = _ref.minChildAge,
    maxChildAge = _ref.maxChildAge,
    isSearcher = _ref.isSearcher;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var containerRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isOverflown = _useState2[0],
    setIsOverflown = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var handleClose = function handleClose() {
    return setIsOpen(false);
  };
  var handleOpen = function handleOpen() {
    return setIsOpen(true);
  };
  var options = makeOptions(minChildAge, maxChildAge);
  (0, _react.useEffect)(function () {
    var _containerRef$current;
    var elRect = containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect();
    var distanceToRight = window.innerWidth - ((elRect === null || elRect === void 0 ? void 0 : elRect.right) || 0);
    if (distanceToRight < 150) setIsOverflown(true);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(StyledAddChild, {
    ref: containerRef
  }, /*#__PURE__*/_react["default"].createElement(StyledAddChildButton, {
    onClick: handleOpen,
    $isSearcher: isSearcher
  }, /*#__PURE__*/_react["default"].createElement(StyledPlusIcon, {
    $isSearcher: isSearcher
  }), /*#__PURE__*/_react["default"].createElement("span", null, t('touristsPicker.addChild'))), isOpen ? /*#__PURE__*/_react["default"].createElement(_CustomList["default"], {
    onChoose: onAddChild,
    options: options,
    handleClose: handleClose,
    isOverflown: isOverflown
  }) : null);
};
var StyledAddChild = _styledComponents["default"].div.withConfig({
  displayName: "AddChild__StyledAddChild",
  componentId: "sc-1cxg0o6-0"
})(["height:50px;display:flex;justify-content:center;align-items:center;"]);
var StyledAddChildButton = _styledComponents["default"].span.withConfig({
  displayName: "AddChild__StyledAddChildButton",
  componentId: "sc-1cxg0o6-1"
})(["font-size:14px;color:", " display:inline-flex;cursor:pointer;justify-content:center;align-items:center;position:relative;gap:4px;"], function (_ref2) {
  var $isSearcher = _ref2.$isSearcher;
  return $isSearcher ? "var(--secondary);" : "var(--secondary-header);";
});
var StyledPlusIcon = (0, _styledComponents["default"])(_Plus["default"]).withConfig({
  displayName: "AddChild__StyledPlusIcon",
  componentId: "sc-1cxg0o6-2"
})(["height:16px;path{fill:", ";}"], function (_ref3) {
  var $isSearcher = _ref3.$isSearcher;
  return $isSearcher ? "var(--secondary);" : "var(--secondary-header);";
});
var _default = exports["default"] = AddChild;